module.exports = __webpack_public_path__ + "static/media/MOHAMAD DABAAN.29b7c37e.png";